import { render, staticRenderFns } from "./SetAssignee.vue?vue&type=template&id=4cf29d6c&lang=html&"
import script from "./SetAssignee.vue?vue&type=script&lang=js&"
export * from "./SetAssignee.vue?vue&type=script&lang=js&"
import style0 from "./SetAssignee.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports